import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillMarketingConsent,
  ITrackingFillMarketingConsentParameters,
} from '../shared/fillMarketingConsent';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export interface ITrackConfirmLeadDetailsParameters
  extends ITrackingFillMarketingConsentParameters,
    ITrackingFillRewardCampaignParameters,
    ITrackingFillItemsParameters,
    Pick<ITrackingProductPageBaseParameters, 'leadId'> {}

export const trackConfirmLeadDetails = (
  parameters: ITrackConfirmLeadDetailsParameters,
): void => {
  const { leadId } = parameters;

  return track({
    event: 'reward_gateway',
    step_number: '1',
    step_name: 'lead-submission',
    intent: 'Confirm Lead Details',
    login_method: '',
    search_result_parameter: '',
    ...fillMarketingConsent(parameters),
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
    ...fillItems(parameters),
    component_type: 'bottom-sticky',
    component_title: 'CTA_Confirm Details',
  });
};
